import {openNetworkHealthCenterSection} from '../maintenanceTabs/adapter';

/**
 * Canvas Maintenance > Network Health Center.
 *
 * A destination rather than a record collection: it shows the sites, access points and clients that are currently unhealthy,
 * and nothing inside it is something the agent acts on yet. So it declares
 * `options` and `view` and no resolver, filter or modal - publishing
 * operations no handler backs is the disagreement the navigation inventory
 * exists to record.
 */
const networkHealthCenterPlugin = {
	id: 'network_health_center',
	version: 1,
	commandVersion: 1,
	resource: 'network_health_center',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.network_health_center': openNetworkHealthCenterSection,
	},
};

export default networkHealthCenterPlugin;
